<script setup lang="ts">
import { defineProps, PropType } from 'vue'
import type { Component } from 'vue'

const props = defineProps({
    link: {
        type: String,
        required: true
    },
    text: {
        type: String,
        required: true
    },
    icon: {
        type: Object as PropType<Component>,
        required: true
    },
    name: {
        type: String,
        required: true
    },
    blink: {
        type: Boolean,
        default: false
    }
})
</script>

<template>
    <router-link
        :to="props.link"
        :id="'nav-item-' + props.name"
        class="flex flex-col group relative items-center w-16 h-16 rounded-full p-3 hover:text-red-800 transition hover:bg-orange-100 active:bg-orange-100"
    >
        <component :is="props.icon" class="[
        'w-full z-10 h-full mb-1 text-white transition-colors duration-200 group-hover:text-red-800 group-active:text-red-900',
        { 'animate-pulse': props.blink }
      ]" />
        <span class="[
        'z-10 text-xs text-white transition-colors duration-200 group-hover:text-red-800 group-active:text-red-900',
        { 'animate-pulse': props.blink }
      ]">
      {{ props.text }}
    </span>

        <div v-if="blink" class="z-2 absolute top-1/2 left-1/2 w-8 h-8 bg-orange-600 rounded-full animate-ping transform -translate-x-1/2 -translate-y-1/2"></div>
    </router-link>
</template>

<style scoped>

</style>
